import { useContext, useState } from "react";
import { useFetchReceipt } from "../../app/queries/receipts";
import { NetworkErrorAlertContext } from "../../context/NetworkErrorAlert";
import {
  getReceiptKind,
  getReceiptLookupId,
} from "./mapNotification";
import { NotificationItem, PayoutReceipt } from "./types";

export const useNotificationReceipt = () => {
  const { onShowAlert } = useContext(NetworkErrorAlertContext);
  const { mutateAsync: fetchReceipt, isLoading: receiptLoading } =
    useFetchReceipt();
  const [receiptOpen, setReceiptOpen] = useState(false);
  const [receipt, setReceipt] = useState<PayoutReceipt | null>(null);
  const [receiptError, setReceiptError] = useState<string | null>(null);

  const closeReceipt = () => {
    setReceiptOpen(false);
    setReceipt(null);
    setReceiptError(null);
  };

  const downloadReceipt = async (notification: NotificationItem) => {
    const kind = getReceiptKind(notification.apiType);
    const lookupId = getReceiptLookupId(
      notification.apiType,
      notification.metadata ?? {}
    );

    if (!kind || !lookupId) {
      onShowAlert?.(null, "Receipt is not available for this notification.");
      return;
    }

    setReceiptOpen(true);
    setReceipt(null);
    setReceiptError(null);

    try {
      const data = await fetchReceipt({ kind, id: lookupId });
      setReceipt(data);
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Unable to load receipt.";
      setReceiptError(message);
      onShowAlert?.(error, message);
    }
  };

  return {
    receiptOpen,
    receipt,
    receiptError,
    receiptLoading,
    downloadReceipt,
    closeReceipt,
  };
};
